import { Button, Container, Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import styles from '../style.module.scss';
import CarouselComponent from './CarouselSection';

const ReviewComponent = () => {
  return (
    <div className={styles.reviewContainer}>
      <Container maxWidth="lg">
        <div className={styles.InfoDiv}>
          <Grid container spacing={2}>
            <Grid item md={12} xl={12} lg={12} sm={12} xs={12}>
              <h2 className={styles.secondaryText}>
                Thousands of sellers use Falcon <br />
                <span className="text-muted pt-4"> to grow their bussiness.</span>
              </h2>
              <CarouselComponent />
            </Grid>
            <Grid item md={8} lg={8} xl={8} sm={12} xs={12}></Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
};
export default ReviewComponent;
